import { AppDispatch } from '@/main'
import { type RootState } from '@/store'
import { useDispatch, useSelector } from 'react-redux'

export const useStoreState = useSelector.withTypes<RootState>()
export const useStoreDispatch = () => useDispatch<AppDispatch>()
